import { createStore } from 'vuex';

import {
    updateJobagent,
    setJobagentState,
    deleteJobagent,
    createJobagent,
} from 'JIX/jobagent/api.js';

const getters = {
    jobagentList(state) {
        const ids = Object.keys(state.jobagents);
        ids.sort();
        return ids.map(id => state.jobagents[id]);
    },
};

const mutations = {
    setJobagent(state, jobagent) {
        state.jobagents[jobagent.id] = jobagent;
    },
    removeJobagent(state, { id }) {
        delete state.jobagents[id];
    },
    clearDuplicateJobagent(state) {
        state.duplicateJobagent = null;
    },
};

const actions = {
    saveJobagent({ commit, _state }, jobagent) {
        return updateJobagent(jobagent)
            .then((res) => commit('setJobagent', res.jobagent));
    },
    createJobagent({ commit, _state }, jobagent) {
        return createJobagent(jobagent)
            .then((res) => commit('setJobagent', res.jobagent));
    },
    deleteJobagent({ commit, _state }, jobagent) {
        return deleteJobagent(jobagent)
            .then(() => commit('removeJobagent', jobagent));
    },
    toggleJobagent({ commit, _state }, jobagent, newEnabled = !jobagent.enabled) {
        return setJobagentState(jobagent, newEnabled)
            .then((res) => commit('setJobagent', res.jobagent));
    },
    setJobagentFrequency({ commit, _state }, { jobagent, newFrequency }) {
        const payload = { id: jobagent.id, frequency: newFrequency };
        return updateJobagent(payload)
            .then((res) => commit('setJobagent', res.jobagent));
    },
};

export default (data) => {
    return createStore({
        state() {
            return { ...data };
        },
        getters,
        mutations,
        actions,
    });
};
